export default {
  redcert: 'redcert',
  iscc: 'iscc',
  other: 'other',
};
